import * as yup from 'yup';

export const formSchema = yup.object({
  billingHoldDescription: yup.string().required('This Field is Required'),
  billingHoldReason: yup.string().required('This Field is Required'),
});
